import { resolveTenant } from "./tenant";

const PREFIX = "myai_excel.session";

function sessionKey(): string | null {
  const t = resolveTenant();
  return t ? `${PREFIX}.${t}` : null;
}

export function getSessionId(): string | null {
  if (typeof window === "undefined") return null;
  const k = sessionKey();
  if (!k) return null;
  return localStorage.getItem(k);
}

export function setSessionId(id: string): void {
  if (typeof window === "undefined") return;
  const k = sessionKey();
  if (!k) return;
  localStorage.setItem(k, id);
}

export function clearSessionId(): void {
  if (typeof window === "undefined") return;
  const k = sessionKey();
  if (!k) return;
  localStorage.removeItem(k);
}
